import { Typography } from '@mui/material'
import { ChevronDown20Regular, ChevronRight20Regular } from '@/components/Icon'
import Pressable from '@/theme/Pressable'

export default function TimelineHeader({
  expanded,
  streaming,
  label,
  onToggle,
}) {
  return (
    <Pressable
      aria-expanded={expanded}
      disabled={streaming}
      onClick={onToggle}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: 'var(--app-thought-font-size)',
        fontWeight: 'var(--app-font-weight-medium)',
        color: 'var(--app-text-secondary)',
      }}
    >
      <Typography
        component="span"
        className={streaming ? 'thoughtShimmerText' : undefined}
        sx={{
          fontSize: 'var(--app-thought-font-size)',
          fontWeight: 'var(--app-font-weight-medium)',
          color: streaming ? undefined : 'var(--app-text-secondary)',
        }}
      >
        {label}
      </Typography>
      {!streaming ? (
        expanded ? (
          <ChevronDown20Regular fontSize={14} />
        ) : (
          <ChevronRight20Regular fontSize={14} />
        )
      ) : null}
    </Pressable>
  )
}
